// extracted by mini-css-extract-plugin
export default {"emailText":"ContactEmail_emailText__eFrF2","contactEmailContainer":"ContactEmail_contactEmailContainer__c94cZ"};